export default {
  trackEvent({
    category,
    action,
    // eslint-disable-next-line camelcase
    opt_label,
    // eslint-disable-next-line camelcase
    opt_value = Date.now(),
  } = {}) {
    if (typeof _hmt === 'undefined') return;
    // eslint-disable-next-line no-undef
    _hmt.push([
      '_trackEvent',
      category,
      action,
      // eslint-disable-next-line camelcase
      opt_label,
      // eslint-disable-next-line camelcase
      opt_value,
    ]);
  },
};
